import { useNavigate } from "react-router-dom";

import EditIcon from '@mui/icons-material/Edit';


function SiteCard({site}) {

  const navigate = useNavigate();

  const siteFields = 
    [
      "category",
      "url", 
      "address_url",
      "notes",
    ];

  const handleClick = () => {
    window.open(site.url);
  }

  const handleEdit = (siteId) => 
    (e) => {
      e.stopPropagation();
      navigate(`/admin/sites/${siteId}/edit`);
  }

  return (
    <div className='site-card' onClick={handleClick}>
      <EditIcon onClick={handleEdit(site.id)} className='icon site-edit'/>
      <div className='site-field site-name'> 
        <span>{site.name}</span>
        <EditIcon onClick={handleEdit(site.id)} className='icon site-edit-mobile'/>
      </div> 
      {siteFields.map((field) => 
        {
          return (
            <div className="site-field" key={field}>
              {site[field]}
            </div>
          )
        })

      }            
    </div>
  );

}

export default SiteCard;


      

                





